module.exports = __webpack_public_path__ + "static/media/MSungHK-Medium.eef7efbe.svg";